import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useForm } from "antd/lib/form/Form";

import { connect, useDispatch } from "react-redux";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";

import DetailsForm from "./DetailsForm";
import TermsForm from "./TermsForm";
import Preview from "./Preview";
import { Button, Card, Col, Flex, Row, Steps, Typography } from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import styles from "../../../../../assets/styles/styles";
import LoanAccChargeForm from "./ChargeForm";
import CustomButton from "../../../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const { Text } = Typography;

const NewLoanAccForm = (props) => {
  const {
    userData,
    accountLinkingOptions,
    customerDetail,
    productData,
    onChangeProduct,
    loanOfficerOptions,
    loanPurposeOptions,
    fundOptions,
    termFrequencyTypeOptions,
    repaymentFrequencyTypeOptions,
    repaymentFrequencyNthDayTypeOptions,
    repaymentFrequencyDaysOfWeekTypeOptions,
    interestTypeOptions,
    amortizationTypeOptions,
    interestCalculationPeriodTypeOptions,
    transactionProcessingStrategyOptions,
    chargeOptions,
    loanCollateralOptions,
    loanAccountDetails,
    form,
    onSearch,
    handleSearchInTable,
    customerInfo,
    showDetailsForm,
    allowPartialPeriodInterestCalcualtion,
    handleAllowPartialPeriodInterestCalcualtion,
    handleIsEqualAmortization,
    isEqualAmortization,
    productTemplate,
    isProductSelected,
    chargeTableSource,
    setChargeTableSource,
    penaltyTableSource,
  } = props;

  const { session } = userData;
  const navigate = useNavigate();
  // const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [collateralTableSource, setCollateralTableSource] = useState([]);
  const [disbursementDataList, setDisbursementDataList] = useState([]);
  const [chargesValue, setChargesValue] = useState(null);
  const [termsValues, setTermsValues] = useState({});

  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState({
    details: null,
    terms: null,
    charges: null,
  });

  const onChange = (value) => {
    setCurrent(value);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const handleLoanType = (valueParam) => {
    return productTemplate.hasOwnProperty("clientId") && productTemplate.hasOwnProperty("groupId")
      ? (valueParam.loanType = "jlg")
      : productTemplate.hasOwnProperty("clientId")
        ? (valueParam.loanType = "individual")
        : productTemplate.hasOwnProperty("groupId")
          ? (valueParam.loanType = "group")
          : null;
  };

  function onCancel() {
    navigate("/acc0103", { replace: false });
  }

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;

    values.expectedDisbursementDate = values.expectedDisbursementDate
      ? BOM.DateTime(values.expectedDisbursementDate, "only-date")
      : values.expectedDisbursementDate;

    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    values.repaymentsStartingFromDate = values.repaymentsStartingFromDate
      ? BOM.DateTime(values.repaymentsStartingFromDate, "only-date")
      : values.repaymentsStartingFromDate;

    values.interestChargedFromDate = values.interestChargedFromDate
      ? BOM.DateTime(values.interestChargedFromDate, "only-date")
      : values.interestChargedFromDate;

    setFormData({ ...formData, terms: values });

    values.allowPartialPeriodInterestCalcualtion = allowPartialPeriodInterestCalcualtion;
    values.isEqualAmortization = isEqualAmortization;
    values.disbursementData = disbursementDataList;
    values.rates = [];

    setCurrent(current + 1);
    setTermsValues(values);
    console.log(values);
  };

  const onFinishChargeForm = (values) => {
    console.log(values);
    let tempChargeArray = [];
    let tempCollateralArray = [];
    chargeTableSource.forEach((element, index) => {
      if (element.feeOnMonthDay === "-") {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
        });
      } else {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
          feeOnMonthDay: BOM.DateTimeWithoutYear(element.feeOnMonthDay, "only-date"),
        });
      }
    });
    collateralTableSource.forEach((element, index) => {
      tempCollateralArray.push({
        collateral: element.id,
        quantity: element.value,
      });
    });

    values.charges = tempChargeArray;
    values.collateral = tempCollateralArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
      collateral: values.collateral,
    });
    setCurrent(current + 1);
  };

  const onSubmit = (formValues) => {
    formValues = {
      ...formData.details,
      ...formData.terms,
    };

    // STRICT VALUES
    formValues.charges = formData.charges;
    formValues.collateral = formData.collateral;

    // formValues.charges = formData.payLoadValues;
    formValues.clientId = productTemplate.clientId;

    handleLoanType(formValues);

    delete formValues.daysInMonth;
    delete formValues.daysinYear;
    delete formValues.interestRecalculationCompounding;
    delete formValues.FrequencyForRecalculate;
    delete formValues.advancePayments;
    delete formValues.customerSearch;
    delete formValues.isInterestRecalculationEnabled;
    delete formValues.recalculationCompoundingFrequency;
    delete formValues.nominalInterestRateFrequency;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.LoanAccounts,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newLoanAccountMsg);
          navigate("/detail-loan-account", {
            state: {
              clientId: res.clientId,
              id: res.resourceId,
              statusValue: "submitted and pending approval",
            },
          });

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-loan-account", {
            state: {
              clientId: res.clientId,
              id: res.resourceId,
              statusValue: "submitted and pending approval",
            },
          });
          setIsLoading(false);
        },
      },
    );
  };

  const forms = [
    <DetailsForm
      onFinish={onFinishDetailsForm}
      form={form}
      formData={formData.details}
      accountLinkingOptions={accountLinkingOptions}
      customerDetail={customerDetail}
      productData={productData}
      onChangeProduct={onChangeProduct}
      loanOfficerOptions={loanOfficerOptions}
      loanPurposeOptions={loanPurposeOptions}
      fundOptions={fundOptions}
      loanAccountDetails={loanAccountDetails}
      onSearch={onSearch}
      handleSearchInTable={handleSearchInTable}
      customerInfo={customerInfo}
      showDetailsForm={showDetailsForm}
      termFrequencyTypeOptions={termFrequencyTypeOptions}
      isProductSelected={isProductSelected}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      form={form}
      formData={formData.terms}
      termFrequencyTypeOptions={termFrequencyTypeOptions}
      repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
      repaymentFrequencyNthDayTypeOptions={repaymentFrequencyNthDayTypeOptions}
      repaymentFrequencyDaysOfWeekTypeOptions={repaymentFrequencyDaysOfWeekTypeOptions}
      interestTypeOptions={interestTypeOptions}
      amortizationTypeOptions={amortizationTypeOptions}
      interestCalculationPeriodTypeOptions={interestCalculationPeriodTypeOptions}
      transactionProcessingStrategyOptions={transactionProcessingStrategyOptions}
      loanAccountDetails={loanAccountDetails}
      allowPartialPeriodInterestCalcualtion={allowPartialPeriodInterestCalcualtion}
      handleAllowPartialPeriodInterestCalcualtion={handleAllowPartialPeriodInterestCalcualtion}
      handleIsEqualAmortization={handleIsEqualAmortization}
      isEqualAmortization={isEqualAmortization}
      productTemplate={productTemplate}
      disbursementDataList={disbursementDataList}
      setDisbursementDataList={setDisbursementDataList}
    />,

    <LoanAccChargeForm
      onFinish={onFinishChargeForm}
      form={form}
      chargesOptions={chargeOptions}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      loanCollateralOptions={loanCollateralOptions}
      collateralTableSource={collateralTableSource}
      setCollateralTableSource={setCollateralTableSource}
      setChargesValue={setChargesValue}
      penaltyTableSource={penaltyTableSource}
    />,

    <Preview
      formData={formData}
      loanAccountDetails={loanAccountDetails}
      productTemplate={productTemplate}
      customerInfo={customerInfo}
      chargeTableSource={chargeTableSource}
      collateralTableSource={collateralTableSource}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  return (
    <>
      <Row style={{ marginBottom: 25 }}>
        <Col span={24}>
          {/*Interractive Section */}
          <Row style={{ justifyContent: "space-between" }}>
            {/* Navigation section */}
            <Card style={styles.cardSteps}>
              <Steps
                current={current}
                onChange={onChange}
                direction="vertical"
                style={{ height: "600px" }}
                items={[
                  {
                    title: <Text strong>Details</Text>,
                  },
                  {
                    title: <Text strong>Terms</Text>,
                    disabled: !isProductSelected,
                  },
                  {
                    title: <Text strong>Charges</Text>,
                    disabled: !isProductSelected,
                  },
                  {
                    title: <Text strong>Preview</Text>,
                    disabled: !isProductSelected,
                  },
                ]}
              />
            </Card>

            {/* Form Section */}
            <Card style={styles.cardStepDisplay}>
              <div>{forms[current]}</div>
            </Card>
          </Row>
        </Col>
      </Row>

      {/* Submitt section */}
      <Card
        style={{
          marginBottom: 25,
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Flex justify="space-between" style={{ paddingLeft: "10px", paddingRight: "40px" }}>
          {current === 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              colortext="black"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          {current > 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#15CCAE",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={prevButtonClick}
            >
              Prev
            </Button>
          )}
          {!isLastStep && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#15CCAE",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={nextButtonClick}
              disabled={!isProductSelected}
            >
              Next
            </Button>
          )}

          {BOM.HasPermission("CREATE_LOAN") && isLastStep && (
            <CustomButton
              content="Submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              onClick={onSubmit}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
            />
          )}
        </Flex>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewLoanAccForm);
